import type {KeyTextField} from '@prismicio/client'
import cn from 'classnames'
import type {FieldPath, FieldValues, UseFormRegister} from 'react-hook-form'

export const TextInput = <T extends FieldValues = FieldValues>({
  errors,
  field,
  register,
  required = true,
  className,
}: {
  errors:
    | {
        fieldName: string
      }[]
    | null
  field: {
    name?: KeyTextField
    type?: KeyTextField
    placeholder?: KeyTextField
  }
  register: UseFormRegister<T>
  required?: boolean
  className?: string
}) => (
  <input
    className={cn(
      `
          relative
          col-span-1
          max-h-10
          w-full
          rounded-[4px]
          border
          border-grey-150
          px-3
          py-[18px]
          text-14
          font-normal
          leading-5
          tracking-[.16px]
          placeholder:text-grey-300
          hover:bg-grey-110
          focus:outline-none
          md:max-h-14
          `,
      {
        'outline-1 outline-[red] outline -outline-offset-1': errors?.some((error) => error.fieldName === field.name),
      },
      className,
    )}
    type={field.type || 'text'}
    placeholder={field.placeholder!}
    // field.name is free text from Prismic (e.g. slice.primary.first_name_field[0].name), not a
    // literal known at compile time, so it can never be checked against FieldPath<T> statically.
    {...register(field.name! as FieldPath<T>, {
      required,
    })}
  />
)
